/*
 * filters.js
 *
 * Description: Holds common/global Filters.
 *
 * This file is part of: "http://apps.sundair.com/", "Sundair-2019"
 * Copyright 2018,2019,2020,2021  Sundair GmbH
 * Contact:  http://www.sundair.com/
 * @author Learek <michael.broeker@sundair.com>
 *
 */
import Vue from "vue";
import moment from 'moment';

Vue.filter("first4Chars", str => str.substring(0, 4)); // Unused
Vue.filter("last4Chars", str => str.substring(str.length - 4)); // Unused


/*******************************************************************************
* Filter:: 'moment'
*
* Desc:
* Note: 2014-09-18T04:00:00+0200
* dateIso8601.match(regexIsoDate) =
* ["2013-03-27T12:05:00+0100", "2013", "03", "27", "T", "12", "05", "00", "+", "01", "00"]

* Example:
* dateIso8601 = "2013-03-27T12:05:00+0100"
* ---> getDateFromDateIso8601
* ---> "27.03.2013"
*
* @param {string} dateIso8601 (Date in ISO8601 format)
* @param {string} format (date format that we want to the return data. Default is: "dd.mm.yyyy")
* @param {bool} withTime (With Time added?)
* @return {string}
*/
Vue.filter('moment', function (dateIso8601, format, withTime) {

    var regexIsoDate = '',
        m = '',
        day = '',
        month = '',
        year = '',
        hour = '',
        minute = '',
        result = '';


    format = 'd.m.Y'; // Fake
    withTime = true; // Fake
    regexIsoDate = /^(\d{4})-(\d{2})-(\d{2})(T)(\d{2}):(\d{2}):(\d{2})([\-+])(\d{2})(\d{2})$/;
    m = typeof dateIso8601 === 'string' && dateIso8601.match(regexIsoDate);

    if (m) {
        year = m[1];
        month = m[2];
        day = m[3];
        hour = m[5];
        minute = m[6];

        switch (format) {
            case 'd.m.Y':
                result = day + '.' + month + '.' + year;
                if (withTime) {
                    result += ', ' + hour + ':' + minute + ' Uhr'
                }
                break;
            case 'j.m.y':
                result = parseInt(day, 10) + '.' + month + '.' + year.substr(2, 2);
                if (withTime) {
                    result += ' ' + hour + ':' + minute;
                }
                break;
            case 'H:i':
                result = hour + ':' + minute;
                break;
        }
    }


    return result;
    // return moment(date, moment.ISO_8601).format('DD.MM.YYYY, HH:mm') + ' Uhr'; // de:
    // return moment(date, moment.ISO_8601).format('MMM DD, YYYY HH:mm A'); // en: JAN 30, 2019

});

/*******************************************************************************
* Filter:: 'momentTime'
*
* Desc: Time only.
* Note:
*
* @param {string} dateIso8601 (Date in ISO8601 format)
* @return {string}
*/
Vue.filter('momentTime', function (dateIso8601) {

    var regexIsoDate = '',
        m = '',
        day = '',
        month = '',
        year = '',
        hour = '',
        minute = '',
        result = '';

    regexIsoDate = /^(\d{4})-(\d{2})-(\d{2})(T)(\d{2}):(\d{2}):(\d{2})([\-+])(\d{2})(\d{2})$/;
    m = typeof dateIso8601 === 'string' && dateIso8601.match(regexIsoDate);

    if (m) {
        year = m[1];
        month = m[2];
        day = m[3];
        hour = m[5];
        minute = m[6];

        result = hour + ':' + minute + ' Uhr';
    }


    return result;

});


/*******************************************************************************
* Filter:: 'birthdate'
*
* Desc: Filter: Format Date.
*
* @param {string} date (Date to reformat)
* @return {string}
*/
Vue.filter('birthdate', function (date) {

    if (date !== undefined) {
        return moment(date, moment.ISO_8601).format('DD.MM.YYYY'); // de:
    } else {
        return '';
    }
    // return moment(date, moment.ISO_8601).format('MMM DD, YYYY'); // en: JAN 30, 2019

});

/*******************************************************************************
* Filter:: 'monthname'
*
* Desc: Filter: Format Date.
*
* @param {string} date (Date to reformat)
* @return {string}
*/
Vue.filter('monthname', function (date) {

    let locale = JSON.parse(localStorage.getItem('sdr__lang'));
    if (locale) {
        moment.locale(locale.value); // returns the new locale, in this case 'de'
    } else {
        moment.locale('de'); // returns the new locale, in this case 'de'
    }


    if (date !== undefined) {
        return moment(date, moment.ISO_8601).format('MMM, YYYY').toUpperCase(); // de:
    } else {
        return '';
    }

});

/*******************************************************************************
* Filter:: 'weekday'
*
* Desc: Filter: Format Date.
*
* @param {string} date (Date to reformat)
* @return {string}
*/
Vue.filter('weekday', function (date) {

    let locale = JSON.parse(localStorage.getItem('sdr__lang'));
    if (locale) {
        moment.locale(locale.value); // returns the new locale, in this case 'de'
    } else {
        moment.locale('de'); // returns the new locale, in this case 'de'
    }


    if (date !== undefined) {
        return moment(date, moment.ISO_8601).format('ddd').toUpperCase(); // de:
    } else {
        return '';
    }

});

/*******************************************************************************
* Filter:: 'dayofmonth'
*
* Desc: Filter: Format Date.
*
* @param {string} date (Date to reformat)
* @return {string}
*/
Vue.filter('dayofmonth', function (date) {

    if (date !== undefined) {
        return moment(date, moment.ISO_8601).format('DD'); // de:
    } else {
        return '';
    }

});


/*******************************************************************************
* Filter:: 'currency'
*
* Desc: Filter: Format Sum.
*
* @param {string} sum (Sum to reformat)
* @return {string}
*/
Vue.filter('currency', function (sum) {

    return String(sum).indexOf(".") === -1 ? sum + '.00€' : sum + '€';

});


/*******************************************************************************
* Filter:: 'rndAmntRUAFWZ'
*
* Desc: Filter: Format Value.
*
* @param {string} v (Value to reformat)
* @return {string}
*/
Vue.filter('rndAmntRUAFWZ', function (v) {

    var k,
        p;


    if (v) {
        String(v).replace(',', '.'); /// really useful????
    }

    k = (Math.round(v * 100) / 100).toString();
    k += (k.indexOf('.') == -1) ? '.00' : '00';
    p = k.indexOf('.');

    return k.substring(0, p) + '.' + k.substring(p + 1, p + 3) + '€';

});